import { PropsWithChildren } from "react";
import { Button, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import classNames from "classnames";
import "./styles.scss";

export const PopupContainer = ({
  children,
  title,
  onClose,
  className,
  maxWidth = "640px",
}: PropsWithChildren<{
  title?: string;
  onClose: () => void;
  className?: string;
  maxWidth?: string | number;
}>) => {
  return (
    <div className="popup-container">
      <div
        className={classNames("popup-content", className)}
        style={{ maxWidth }}
      >
        <Stack
          className="popup-header"
          justifyContent={title ? "space-between" : "flex-end"}
          direction="row"
        >
          {title && <h2 className="popup-title font-size-5">{title}</h2>}
          <Button
            color={"black" as any}
            variant="text"
            onClick={onClose}
            className="close-button"
          >
            <CloseIcon />
          </Button>
        </Stack>
        <div className="popup-body">{children}</div>
      </div>
    </div>
  );
};
